import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=d7395600&scoped=true"
import script from "./Chat.vue?vue&type=script&setup=true&lang=js"
export * from "./Chat.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=d7395600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7395600",
  null
  
)

export default component.exports